export default {"src":"/_next/static/media/instant.23165301.svg","height":93,"width":61};